import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosResponse } from "axios";
import jwt_decode from "jwt-decode";
import cookies from "js-cookie";

import repo from "@/lib/repository";
import { TokenRequest, TokenResponse, UserSession } from "@/lib/types";
import { validateServerError } from "@/lib/utils";

export const getSignIn = createAsyncThunk("profile/get/sign-in", async (form: TokenRequest, { rejectWithValue }) => {
  try {
    const response = await repo
      .post<TokenResponse, AxiosResponse<TokenResponse, TokenRequest>, TokenRequest>("/users/sign-in", form, { headers: { "content-type": "application/json" } });
    cookies.set("access_token", response.data.access_token, { path: "/" });
    return jwt_decode<UserSession>(response.data.access_token);

  }
  catch (error: any) {
    return rejectWithValue(validateServerError(error));
  }
});

export const getSignOut = createAsyncThunk("profile/get/sign-out", async (_, { rejectWithValue }) => {
  try {
    await repo
      .post("/users/sign-out", {}, { headers: { "content-type": "application/json" } });
    cookies.remove("access_token", { path: "/" });
    return null;
  }
  catch (error: any) {
    cookies.remove("access_token", { path: "/" });
    return rejectWithValue(validateServerError(error));
  }
});

export const getProfile: any = createAsyncThunk("profile/get/profile", async ({ token, role }: any, { rejectWithValue }) => {

  // try {
  //   const response = await API.get<GetProfileResponse>(url, {
  //     headers: {
  //       "content-type": "application/json",
  //       Authorization: `Bearer ${token}`,
  //     }
  //   })
  //   const { data } = response.data
  //   return data;
  // } catch (e) {
  //   rejectWithValue(e)
  // }

  return null;
});
